// src/api/notification/parentNotificationApi.js
import apiClient from '../../index';

export const createParentNotification = async (notificationData) => {
  try {
    const response = await apiClient.post('/api/pnotify/', notificationData);
    return response.data;
  } catch (error) {
    console.error('Error creating parent notification:', error);
    throw error;
  }
};

export const getAllParentNotifications = async () => {
  try {
    const response = await apiClient.get('/api/pnotify/');
    // console.log('Parent notifications:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching all parent notifications:', error);
    throw error;
  }
};

export const deleteAllParentNotifications = async () => {
  try {
    const response = await apiClient.delete('/api/pnotify/');
    return response.data;
  } catch (error) {
    console.error('Error deleting all parent notifications:', error);
    throw error;
  }
};

export const markParentNotificationAsRead = async (notifId) => {
  if (!notifId) throw new Error('Notification ID is required');

  try {
    const response = await apiClient.get(`/api/pnotify/${notifId}`);
    return response.data;
  } catch (error) {
    console.error(
      `Error fetching parent notification with ID ${notifId}:`,
      error
    );
    throw error;
  }
};

export const deleteParentNotification = async (notifId) => {
  if (!notifId) throw new Error('Notification ID is required');

  try {
    const response = await apiClient.delete(`/api/pnotify/${notifId}`);
    return response.data;
  } catch (error) {
    console.error(
      `Error deleting parent notification with ID ${notifId}:`,
      error
    );
    throw error;
  }
};
